var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnarchived(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 364 414",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.75 115V98.5H141.25V115H219.75Z",
    fill: "#C99B17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M259 59.1V115H239.375V68.95H190.312V19.7H121.625V115H102V19.7C102 14.2825 103.922 9.64479 107.765 5.78688C111.608 1.92896 116.228 0 121.625 0H200.125L259 59.1Z",
    fill: "#C99B17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269 122H92L77 137H284L269 122Z",
    fill: "#C99B17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.197 313.409L165.694 271.122V370.002H194.306V271.122L236.803 313.619L257 293.002L180 216.002L103 293.002L123.197 313.409Z",
    fill: "#C99B17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6863 86H92V102H81.3137L27.3137 156H336.686L282.686 102H270V86H289.314L364 160.686V413.5H0V160.686L74.6863 86ZM348 172H16V397.5H348V172Z",
    fill: "#C99B17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchived);
export default __webpack_public_path__ + "static/media/Unarchived.79ae19780d73c272ef19160c9fe8cb9b.svg";
export { ForwardRef as ReactComponent };